import { SmartSearchParams } from "../hooks/useSmartSearchParams";

export const createIdFromSmartSearchParams = (params: SmartSearchParams) => {
  return `${params.type}Id` as "locationId" | "charityId" | "distributorId";
};
